
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      role: 'Real Estate Investor',
      company: 'Rodriguez Properties',
      image: 'https://public.readdy.ai/ai/img_res/d279d8a0f9025dff70b63f3894e2ece1.jpg',
      text: 'Fast Funding Capital found me a fix & flip loan with better terms than I could get anywhere else. Their brokerage model really works – they shopped multiple lenders and saved me both time and money.',
      rating: 5,
      loanType: 'Fix & Flip Loan'
    },
    {
      name: 'Sarah Chen',
      role: 'Commercial Property Owner',
      company: 'Chen Commercial Group',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20Sarah%20Chen%20in%20her%2030s%2C%20confident%20expression%2C%20wearing%20professional%20attire%2C%20modern%20office%20setting%2C%20successful%20commercial%20property%20owner%2C%20professional%20portrait&width=400&height=400&seq=testimonial-2&orientation=squarish',
      text: 'The DSCR loan process was incredibly smooth. No income verification hassles, and they understood my investment strategy perfectly. Closed in 3 weeks with excellent terms.',
      rating: 5,
      loanType: 'DSCR Loan'
    },
    {
      name: 'David Thompson',
      role: 'Property Developer',
      company: 'Thompson Development',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20David%20Thompson%20in%20his%2050s%2C%20experienced%20property%20developer%2C%20wearing%20casual%20business%20attire%2C%20construction%20site%20background%2C%20confident%20successful%20developer%20portrait&width=400&height=400&seq=testimonial-3&orientation=squarish',
      text: 'I needed bridge financing for a time-sensitive deal. Fast Funding Capital came through with funding in 10 days. Their expertise in commercial real estate is unmatched.',
      rating: 5,
      loanType: 'Bridge Loan'
    },
    {
      name: 'Jennifer Walsh',
      role: 'Multifamily Investor',
      company: 'Walsh Real Estate Holdings',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20Jennifer%20Walsh%20in%20her%2040s%2C%20multifamily%20property%20investor%2C%20wearing%20professional%20business%20suit%2C%20apartment%20building%20background%2C%20successful%20real%20estate%20investor%20portrait&width=400&height=400&seq=testimonial-4&orientation=squarish',
      text: 'Their advisory support was invaluable. They helped position my portfolio for maximum approvals and connected me with the right lender for my multifamily acquisition.',
      rating: 5,
      loanType: 'Rental Property Loan'
    },
    {
      name: 'Robert Kim',
      role: 'Construction Company Owner', 
      company: 'Kim Construction LLC',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20Robert%20Kim%20in%20his%2040s%2C%20construction%20company%20owner%2C%20wearing%20business%20casual%20attire%2C%20construction%20site%20background%2C%20successful%20contractor%20and%20developer%20portrait&width=400&height=400&seq=testimonial-5&orientation=squarish',
      text: 'Ground-up construction financing can be complex, but Fast Funding Capital made it simple. They found a lender who understood our project and provided flexible draw schedules.',
      rating: 5,
      loanType: 'Ground-Up Construction'
    },
    {
      name: 'Amanda Foster',
      role: 'Real Estate Wholesaler',
      company: 'Foster Property Solutions',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20Amanda%20Foster%20in%20her%2030s%2C%20real%20estate%20wholesaler%2C%20wearing%20modern%20business%20attire%2C%20office%20setting%20with%20property%20documents%2C%20successful%20real%20estate%20professional%20portrait&width=400&height=400&seq=testimonial-6&orientation=squarish',
      text: 'When I need transactional funding for double closings, Fast Funding Capital delivers. 24-48 hour funding has saved multiple deals. They truly understand the wholesale business.',
      rating: 5,
      loanType: 'Transactional Funding'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Real stories from real estate investors and business owners who have successfully secured funding through our network of lenders.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 border border-gray-100">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                  <p className="text-gray-500 text-xs">{testimonial.company}</p>
                </div>
              </div>

              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400"></i>
                  </div>
                ))}
                <span className="ml-2 text-sm text-gray-600">({testimonial.rating}.0)</span>
              </div>

              <p className="text-gray-700 mb-4 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              <div className="bg-blue-50 rounded-lg px-3 py-2 inline-block">
                <span className="text-blue-700 font-medium text-sm">{testimonial.loanType}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 text-white">
            <h3 className="text-3xl font-bold mb-4">
              Join Thousands of Satisfied Clients
            </h3>
            <p className="text-blue-100 mb-6 max-w-2xl mx-auto">
              Ready to experience the Fast Funding Capital difference? Get your no-obligation pre-approval and see why investors choose us for their financing needs.
            </p>
            <button 
              onClick={() => {
                const element = document.getElementById('pre-approval');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Your Pre-Approval
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
